import { render, staticRenderFns } from "./SerialNumberInput.vue?vue&type=template&id=50bd6b42&"
import script from "./SerialNumberInput.vue?vue&type=script&lang=ts&"
export * from "./SerialNumberInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports